export default ()=> {
  if(typeof window !== "undefined"){
    return window.location.search.substring(1).split("&")
    .filter(x => !!x && x.length > 0)
    .map(kv => kv.split('='))
    .reduce((a, b) => ({...a, [b[0]]: b[1]}), {})
  } else {
    return {}
  }
}